import React from 'react';
import Typography from '@mui/material/Typography';

import { TreatmentInfo } from '../../types/Diagnose.type';
import { TypographyVariant } from '@mui/material/styles';

const splitAndRemoveEmpty = (text: string) => {
  const splitted = text.split(/\r?\n/g);
  return splitted.filter((split) => split !== '');
};

const renderSplittedTexts = (
  splittedData: string[],
  variant: TypographyVariant
) => {
  return splittedData.map((text, i) => (
    <Typography variant={variant} style={{ marginBottom: '0.5em' }} key={i}>
      {text}
    </Typography>
  ));
};

export const splitAndRender = (
  text: string | null,
  variant: TypographyVariant = 'body1',
  fallbackText = 'Specific information not available.'
) => {
  if (!text) {
    return fallbackText;
  }
  const splitted = splitAndRemoveEmpty(text);
  return renderSplittedTexts(splitted, variant);
};

export const DiseaseInfo = ({
  treatmentInfo,
}: {
  treatmentInfo: TreatmentInfo;
}) => {
  return (
    <>
      <Typography variant="subtitle1" align="left">
        DISEASE INFO
      </Typography>
      <Typography align="left" paragraph>
        {splitAndRender(treatmentInfo.Info)}
      </Typography>
      <Typography variant="subtitle1" align="left">
        GENERAL TREATMENT INFO
      </Typography>
      <Typography align="left" paragraph>
        {splitAndRender(
          treatmentInfo.TreatmentInfo,
          'body1',
          'Treatment information for this disease/condition not yet available.'
        )}
      </Typography>
      <Typography variant="subtitle1" align="left">
        FOLLOW UP
      </Typography>
      <Typography align="left" paragraph>
        {splitAndRender(
          treatmentInfo.FollowUp,
          'body1',
          'Specific follow up information for this treatment not available.'
        )}
      </Typography>
    </>
  );
};
